import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import { RecommendationBand as AssetBand } from "../../recommendations/components/Bands/RecommendationBand";
import { FormField } from "../../recommendations/components/Bands/FormField";
import useSurveyAssetFrom from "./useSurveyAssetFrom";
import { DYNAMIC_FIELD_TYPES } from "../../common/constants";
import { useDispatch, useSelector } from "react-redux";
import { autoFields, dropdownKeys } from "../constants";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import ServiceLifeChangeConfirmationModal from "../../common/components/ServiceLifeChangeConfirmationModal";
import Portal from "../../common/components/Portal";
import VoiceNotesTable from "./VoiceNotesTable";
import Loader from "../../common/components/Loader";
import VideoTable from "../../mobileRecommendation/components/VideoTable";
import InfoImages from "./InfoImage";
import imageActions from "../../images/actions";
import DynamicForm from "./NewFieldDynamicForm/DynamicForm";
import _, { uniqBy } from "lodash";
import { FilterSearch } from "../../mobileRecommendation/components/FilterModal/FilterSearch";
import actions from "../actions";
import ChangeConfirmationModal from "../../common/components/ChangeConfirmationModal";
import Draggable from "react-draggable";
import RenderImageBand from "./RenderImageBand";
import SignatureViewModal from "./SignatureViewModal";
import signatureIcon from "../../../assets/img/signature-icon.svg";
import { useParams } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import AIAnalyse from "./AIAnalyse/AIAnalyse";
import mobileRecommendationAction from "../../mobileRecommendation/actions";
import MobileRecommendationForm from "../../mobileRecommendation/components/MobileRecommendationForm";
import { checkPermission } from "../../../config/utils";
import { RecommendationChecklist } from "../../recommendations/components/Bands/Checklist";
import { ImageViewV2 } from "../../common/components/ImageComponents/ImageViewModalV2";
import { getVisibilityConditionFields, shouldShowField as shouldShowFieldByVisibility } from "./visibilityConditionUtils";
import "./survey-project.css";

const AssetsForm = ({ isLoading, basicDetails, surveyProject, getInitialSurveyAsset, isMobileRecommendation = false, projectId }) => {
    const {
        data,
        handleChange,
        handleSubmit,
        errorParams,
        showErrorBorder,
        onCancel,
        setShowCancelConfirmModal,
        showCancelConfirmModal,
        cancelForm,
        toggleCreateDynamicForm,
        showCreateDynamicForm,
        initialData,
        handleInputChange,
        fieldSearch,
        setFieldSearch,
        fillEmptyFields,
        hasInvalidFields,
        invalidFields,
        setInvalidFields,
        staticData,
        getSuggestions,
        groupedOptions,
        onDirtyCheck,
        applyAutoPopulateGlobally,
        pendingServiceLifeChange,
        handleServiceLifeChangeApply,
        clearPendingServiceLifeChange
    } = useSurveyAssetFrom({
        initialState: basicDetails,
        surveyProject,
        getInitialSurveyAsset,
        isMobileRecommendation,
        projectId
    });
    const { id } = useParams();
    const { id: ParamId } = useParams();

    const [imageLoaded, setImageLoaded] = useState(false);
    const [pendingBlurChange, setPendingBlurChange] = useState(null);
    const [imagePopup, setImagePopup] = useState(false);
    const [signaturePopup, setSignaturePopup] = useState(false);
    const [imageList, setImageList] = useState(null);
    const [selectedImage, setSelectedImage] = useState();
    const viewImageHandler = useRef(null);
    const resetModalRef = useRef(null);
    const zoomInModalRef = useRef(null);
    const zoomOutModalRef = useRef(null);
    const resetRef = useRef(null);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);
    const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);

    const [showAdditionalModalButtons, setShowAdditionalModalButtons] = useState(false);
    const { dropDownList, dropDownLoading, manufacturerCount } = useSelector(state => state.assetReducer);
    const {
        updateSurveyAssetFieldsResponseLoading,
        getAssetVoiceNotesResponseLoading,
        uniformatList,
        getSuggestionDropdown,
        getSuggestionDropdownLoading,
        getSurveyAssetImagesById,
        getAssetSignature,
        getAssetSignatureLoading,
        getSurveyRecommendationsImagesById,
        getSurveyAssetById,
        getAssetVoiceNotesResponse
    } = useSelector(state => state.assetSurveyProjectReducer);
    const { getStaticDropdownValues } = useSelector(state => state?.assetSettingsReducer);
    const [showBand, setShowBand] = useState({ band101: true });
    const [showEmptyFieldsFillModal, setShowEmptyFieldsFillModal] = useState({ show: false, fields: null });
    const [activeTab, setActiveTab] = useState("basic");
    const [showFullUniformatDropdowns, setShowFullUniformatDropdowns] = useState({});
    const dispatch = useDispatch();
    const { getStatusDropdwnResponse } = useSelector(state => state?.recommendationStatusReducer);

    const {
        getMobileRecommendationDropdownResponseLoading,
        getMobileRecommendationDropdownResponse,
        updateMobileRecommendationFieldsResponseLoading
    } = useSelector(state => state.mobileRecommendationsReducer);
    const { priorityElementsDropDownResponse } = useSelector(state => state.recommendationsReducer);

    const surveyDetailMainFields = [
        {
            label: "Asset Code",
            key: "code",
            value: getSurveyAssetById?.asset?.code
        },
        {
            label: "Survey Project Name",
            key: "asset_survey_project_name"
        }
    ];

    const surveyDetailRestFields = [
        { label: "Survey Type", key: "survey_type" },
        {
            label: "Surveyor",
            key: "asset_surveyor_name"
        },
        {
            label: "GUID",
            key: "guid"
        },
        {
            label: "Latitude",
            key: "latitude"
        },
        {
            label: "Longitude",
            key: "longitude"
        },
        {
            label: "Surveyed Date",
            key: "asset_surveyed_time"
        },
        {
            label: "Survey Modified Date",
            key: "modified_time"
        },
        {
            label: "Remote Id",
            key: "remote_id"
        },
        {
            label: "Resync",
            key: "resync"
        },
        {
            label: "Date Synced",
            key: "synced_time"
        },
        {
            label: "Created At",
            key: "created_at"
        },
        {
            label: "Updated At",
            key: "updated_at"
        }
    ];

    const initialTabs = [
        { key: "edit", label: isMobileRecommendation ? "Edit Mobile recommendation" : "Edit Mobile Asset" },
        { key: "image", label: "Images" },
        { key: "voice", label: "Voice Notes" },
        { key: "video", label: "Videos" },
        { key: "ai-analyse", label: "AI Analysis" }
    ];
    const [selectedTabs, setSelectedTabs] = useState("edit");
    const [showFields, setShowFields] = useState([]);
    const [showType, setShowType] = useState(null);

    useEffect(() => {
        return () => {
            dispatch(actions?.resetImageReducer());
        };
    }, []);
    useEffect(() => {
        if (["edit"]?.includes(selectedTabs ?? "")) {
            if (isMobileRecommendation) dispatch(mobileRecommendationAction.getMobileRecommendationById(id));
            else dispatch(actions.getSurveyAssetById(id));
        }
    }, [selectedTabs]);

    useEffect(() => {
        if (selectedTabs === "edit") {
            if (!isMobileRecommendation) dispatch(actions.getSurveyAssetImagesById(id));
            else dispatch(actions.getSurveyRecommendationImagesById(id));
        }
    }, [id]);

    const closeSignaturePopup = () => {
        setSignaturePopup(false);
        dispatch(actions.resetAssetSignature());
    };

    useEffect(() => {
        if (getSurveyAssetImagesById && !isMobileRecommendation) {
            setSelectedImage([...(getSurveyAssetImagesById?.data?.image ?? []), ...(getSurveyAssetImagesById?.data?.added_image ?? [])]?.[0]);
            setImageList({ images: [...(getSurveyAssetImagesById?.data?.image ?? []), ...(getSurveyAssetImagesById?.data?.added_image ?? [])] });
        }
    }, [getSurveyAssetImagesById]);

    useEffect(() => {
        if (getSurveyRecommendationsImagesById && isMobileRecommendation) {
            setShowBand({ ...showBand, ["band1"]: true, ["band2"]: true });
            setSelectedImage(
                [...(getSurveyRecommendationsImagesById?.data?.image ?? []), ...(getSurveyRecommendationsImagesById?.data?.added_image ?? [])]?.[0]
            );
            setImageList({
                images: [...(getSurveyRecommendationsImagesById?.data?.image ?? []), ...(getSurveyRecommendationsImagesById?.data?.added_image ?? [])]
            });
        }
    }, [getSurveyRecommendationsImagesById]);

    useEffect(() => {
        if (selectedImage?.master_image?.s3_image_key || selectedImage?.s3_image_key) {
            setImageLoaded(false);
            const img = new Image();
            img.src = selectedImage?.master_image?.s3_image_key || selectedImage?.s3_image_key;
            img.onload = () => setImageLoaded(true);
        }
    }, [selectedImage]);

    const getValue = (field_type, e, value) => {
        if ([DYNAMIC_FIELD_TYPES.SELECT, "custom_select"].includes(field_type)) {
            return e;
        }
        if (DYNAMIC_FIELD_TYPES.TEXT === field_type) {
            return e?.target?.value ?? "";
        }
        if (DYNAMIC_FIELD_TYPES.NUMBER === field_type) {
            return e?.value ?? "";
        }
        if (DYNAMIC_FIELD_TYPES.CURRENCY === field_type) {
            return value ?? "";
        }
        if (DYNAMIC_FIELD_TYPES.MEMO === field_type) {
            return value;
        }
        if (DYNAMIC_FIELD_TYPES.BOOLEAN === field_type) {
            return value;
        }
        if (DYNAMIC_FIELD_TYPES.DATE === field_type) {
            return e;
        }
    };

    const renderImagePopup = () => {
        if (!imagePopup) return null;
        return (
            <Portal
                body={
                    <ImageViewV2
                        initialImages={imageList?.images ?? []}
                        initialSelectedId={null}
                        onCancel={() => setImagePopup(false)}
                        isSurveyAssetView={true}
                        noOverlay={true}
                    />
                }
                noOverlay={true}
                onCancel={() => setImagePopup(false)}
            />
        );
    };

    const renderSignaturePopup = () => {
        if (!signaturePopup) return null;
        return (
            <Portal
                body={
                    <SignatureViewModal
                        signature={getAssetSignature?.data}
                        loading={getAssetSignatureLoading}
                        onReload={() => dispatch(actions.getAssetSignature("mobile_asset", id))}
                        onCancel={closeSignaturePopup}
                    />
                }
                onCancel={closeSignaturePopup}
            />
        );
    };

    const updateImageComment = imageData => {
        const { image_ids = [], caption = "", id = "", description = "", captionchange = false, tags = [], removed_tags = [] } = imageData;
        if (isMobileRecommendation)
            dispatch(
                imageActions.updateImage(
                    {
                        image_ids: id ? [id] : image_ids,
                        caption: description ? description : caption,
                        captionchange,
                        tags,
                        removed_tags,
                        mobile_recom_id: ParamId
                    },
                    id,
                    "mobile_recommendations"
                )
            );
        else dispatch(actions.updateAssetImageComment(id ? id : image_ids?.[0], { caption: description ? description : caption }));
    };

    const renderInvalidModal = () => {
        if (!invalidFields) return null;
        return (
            <Portal
                body={
                    <ChangeConfirmationModal
                        heading={`Are you sure you want to save this ${isMobileRecommendation ? "recommendation" : "asset"}?`}
                        paragraph={
                            <p>
                                There are still some fields that are new/invalid. Are you sure you want to save this
                                {isMobileRecommendation ? " recommendation" : " asset"}?
                                {invalidFields?.map(e => (
                                    <>
                                        <br />• {e?.label}: {e?.value}
                                    </>
                                ))}
                            </p>
                        }
                        onCancel={() => setInvalidFields(null)}
                        onOk={() => {
                            handleSubmit();
                            setInvalidFields(null);
                        }}
                    />
                }
                onCancel={() => setInvalidFields(null)}
            />
        );
    };

    const renderCancelConfirmationModal = () => {
        if (!showCancelConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to clear and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => {
                            onDirtyCheck();
                            setShowCancelConfirmModal(false);
                        }}
                        onYes={cancelForm}
                    />
                }
                onCancel={() => setShowCancelConfirmModal(false)}
            />
        );
    };

    const renderEmptyFieldsConfirmationModal = () => {
        if (!showEmptyFieldsFillModal?.show) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to populate all empty text fields with NA?"}
                        message={"This action will place the value NA in all empty text fields, are you sure you want to proceed?"}
                        onNo={() => setShowEmptyFieldsFillModal({ show: false, fields: null })}
                        onYes={() => {
                            fillEmptyFields(showEmptyFieldsFillModal?.fields ?? []);
                            setShowEmptyFieldsFillModal({ show: false, fields: null });
                        }}
                    />
                }
                onCancel={() => setShowEmptyFieldsFillModal({ show: false, fields: null })}
            />
        );
    };

    const renderServiceLifeChangeConfirmationModal = () => {
        if (!pendingServiceLifeChange) return null;
        const {
            changes = [],
            serviceLifeChanged,
            newServiceLife,
            current = {},
            source = {},
            sourceLabel = "Uniformat",
            entityLabel = "Asset"
        } = pendingServiceLifeChange;
        const serviceLife = newServiceLife;
        const installedYear = current?.installedYear;
        const hasInstalledYear = !!installedYear && !!current?.hasInstalledYearField;
        const getEndOfServiceLife = (year, life) => (parseInt(year) && parseInt(life) ? parseInt(year) + parseInt(life) : "");
        const getUsefullLifeRemaining = (year, life) =>
            parseInt(year) && parseInt(life) ? parseInt(year) + parseInt(life) - new Date().getFullYear() : "";
        const currentServiceLife = current?.serviceLife;
        const oldULR =
            current?.usefulLifeRemaining || current?.usefulLifeRemaining === 0
                ? current?.usefulLifeRemaining
                : getUsefullLifeRemaining(installedYear, currentServiceLife);
        const showEndOfServiceLife = serviceLifeChanged && hasInstalledYear && !!current?.hasEndOfServiceLifeField;
        const showUsefulLifeRemaining = serviceLifeChanged && hasInstalledYear && !!current?.hasUsefulLifeRemainingField;
        const rows = [
            ...changes,
            ...(showEndOfServiceLife
                ? [
                      {
                          field: "end_of_service_life",
                          label: "End of Service Life",
                          derived: true,
                          from: getEndOfServiceLife(installedYear, currentServiceLife),
                          to: getEndOfServiceLife(installedYear, serviceLife)
                      }
                  ]
                : []),
            ...(showUsefulLifeRemaining
                ? [
                      {
                          field: "usefull_life_remaining",
                          label: "Useful Life Remaining",
                          derived: true,
                          from: oldULR,
                          to: getUsefullLifeRemaining(installedYear, serviceLife)
                      }
                  ]
                : [])
        ];

        return (
            <Portal
                body={
                    <ServiceLifeChangeConfirmationModal
                        sourceLabel={sourceLabel}
                        entityLabel={entityLabel}
                        sourceFrom={source?.from ?? ""}
                        sourceTo={source?.to ?? ""}
                        rows={rows}
                        onApply={handleServiceLifeChangeApply}
                        onCancel={clearPendingServiceLifeChange}
                    />
                }
                onCancel={clearPendingServiceLifeChange}
            />
        );
    };

    const renderCreateDynamicFormModal = () => {
        if (!showCreateDynamicForm?.show) return null;
        return (
            <Portal
                body={
                    <DynamicForm
                        entity={showCreateDynamicForm?.entity}
                        nameFieldValue={showCreateDynamicForm?.value}
                        onCancel={() => toggleCreateDynamicForm(null)}
                        autoFields={showCreateDynamicForm?.autoFields ?? {}}
                        dropDownOptions={showCreateDynamicForm?.dropDownOptions ?? {}}
                        onFormSubmit={showCreateDynamicForm?.onFormSubmit}
                        projectId={showCreateDynamicForm?.autoFields?.project_ids ?? ""}
                        clientId={showCreateDynamicForm?.autoFields?.client_id ?? ""}
                        isMobileRecommendation={isMobileRecommendation}
                    />
                }
            />
        );
    };

    const disabledKeys = ["assets.current_age", "assets.end_of_service_life", "assets.usefull_life_remaining", "usefull_life_remaining"];

    const renderUniformatFullDropdownToggle = dropdownKey => (
        <span className="d-block mt-2 mb-1 font-weight-normal d-flex" onClick={e => e.stopPropagation()}>
            <input
                type="checkbox"
                className="uniformat-full-dropdown-toggle__checkbox"
                checked={!!showFullUniformatDropdowns?.[dropdownKey]}
                onChange={e => setShowFullUniformatDropdowns({ ...showFullUniformatDropdowns, [dropdownKey]: e.target.checked })}
            />
            <div className="uniformat-full-dropdown-toggle__text">Show full dropdown values</div>
        </span>
    );

    const getFilteredUniformatOptions = (fieldName, eachBand, showFullDropdown = false) => {
        const level = Number(fieldName?.match(/uniformat_level_(\d+)_id/)?.[1]);
        const list = uniformatList?.[fieldName] ?? [];
        if (!level || !list?.length) return [];

        if (level === 1 || showFullDropdown) {
            return list.map(opt => ({ ...opt, label: opt.name, value: opt.id }));
        }

        const parentFields = Array.from({ length: level - 1 }, (_, i) => `assets.uniformat_level_${level - 1 - i}_id`);

        const parentEntry = (parentFields || [])
            ?.map(field => ({
                field,
                id: data?.[eachBand]?.[field]?.uuid
            }))
            ?.find(({ id }) => !!id);

        if (!parentEntry) {
            return list.map(opt => ({ ...opt, label: opt.name, value: opt.id }));
        }
        const { field: matchedField, id: selectedId } = parentEntry || {};
        return list.filter(item => item?.[matchedField] === selectedId)?.map(opt => ({ ...opt, label: opt?.name, value: opt?.id }));
    };

    const getFilteredOptions = (levelKey, eachBand) => {
        const hierarchy = [
            "entity",
            "assets.survey_target_id",
            "assets.cs_l1_type_id",
            "assets.cs_l2_category_id",
            "assets.cs_l3_subsystem_id",
            "assets.cs_l4_object_id",
            "assets.cs_l5_equipment_config_id",
            "assets.client_standards_id"
        ];

        if (levelKey === "assets.client_standards_id") {
            const clientList = dropDownList?.["client_standards"] ?? [];

            for (let i = hierarchy.length - 2; i >= 0; i--) {
                const parentKey = hierarchy?.[i];
                const parentValue = data?.[eachBand]?.[parentKey];
                const entityValue = parentValue?.value;
                if (entityValue || parentValue?.uuid) {
                    const filtered = clientList?.filter(item => {
                        const compareValue = parentKey === "entity" ? entityValue : parentValue?.uuid;
                        return item?.[parentKey === "entity" ? "assets.survey_target" : parentKey] === compareValue;
                    });

                    return filtered;
                }
            }
            return clientList;
        }

        const currentIndex = hierarchy?.indexOf(levelKey);
        const currentList = getStaticDropdownValues?.data?.[levelKey] ?? [];

        if (currentIndex === 0) return currentList;

        for (let i = currentIndex - 1; i >= 0; i--) {
            const parentKey = hierarchy?.[i];
            const parentValue = data?.[eachBand]?.[parentKey];
            const entityValue = parentValue?.value;

            if (entityValue || parentValue?.uuid) {
                return currentList?.filter(item => {
                    const compareValue = parentKey === "entity" ? entityValue : parentValue?.uuid;
                    return item?.[parentKey === "entity" ? "survey_target" : parentKey] === compareValue;
                });
            }
        }
        return currentList;
    };

    const recomDropdown = (eachFieldKey, eachFieldValue, eachBand) => {
        const parentMap = {
            region_id: ["site_id"],
            site_id: ["building_id"],
            building_id: ["floor", "addition_id", "main_building_type_id"]
            // trade_id: ["system_id"],
            // system_id: ["sub_system_id"]
        };

        const parentEntry = Object.entries(parentMap).find(([parentKey, children]) => children.includes(eachFieldKey));

        if (parentEntry) {
            const [parentKey] = parentEntry;
            const parentValue = data?.[eachBand]?.[parentKey]?.value;
            if (!parentValue) {
                return [];
            }
        }

        if (eachFieldKey === "recommendation_capital_type_id") {
            return (
                getMobileRecommendationDropdownResponse?.[eachFieldKey]?.map(e => ({
                    id: e?.id,
                    name: e?.display_name
                })) || []
            );
        }
        if (
            eachFieldKey === "manufacturer_id" ||
            eachFieldKey === "assets.manufacturer_id" ||
            eachFieldKey === "asset_conditions" ||
            eachFieldKey === "assets.client_asset_condition_id"
        ) {
            return dropDownList?.[dropdownKeys?.[eachFieldKey]] || [];
        }

        if (eachFieldValue && "priority_element_option" in eachFieldValue) {
            return (priorityElementsDropDownResponse?.priority_elements || [])?.find(e => e?.id === eachFieldKey)?.options || [];
        }

        return (
            getMobileRecommendationDropdownResponse?.[eachFieldKey] ||
            basicDetails?.[eachBand]?.[eachFieldKey]?.field_options?.map(e => ({
                id: e?.value,
                name: e?.value
            })) ||
            []
        );
    };

    const renderBlurConfirmationModal = () => {
        if (!pendingBlurChange) return null;

        const { sourceLabel, targetLabels = [], fieldKey, bandKey, onConfirmChange } = pendingBlurChange;
        const targetText = targetLabels.join(", ");
        const noWrap = { whiteSpace: "nowrap" };
        const wrapText = { overflowWrap: "anywhere" };
        const handleBlurConfirmationClose = () => {
            if (!onConfirmChange && bandKey && fieldKey) {
                handleChange({ name: fieldKey, value: initialData?.[bandKey]?.[fieldKey]?.value ?? "" });
            }
            setPendingBlurChange(null);
        };

        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            <div>
                                <div className="mb-2">Auto Populate Confirmation</div>
                                Updating <strong style={noWrap}>"{sourceLabel}"</strong> Will ALSO update <strong style={wrapText}>"{targetText}"</strong>
                            </div>
                        }
                        message={
                            <div>
                                Click <strong>Yes</strong> to update <strong style={wrapText}>"{targetText}"</strong>, click <strong>No</strong> to update
                                ONLY <strong style={noWrap}>"{sourceLabel}"</strong>
                            </div>
                        }
                        onNo={() => {
                            if (pendingBlurChange?.onConfirmChange) pendingBlurChange?.onConfirmChange(false);
                            setPendingBlurChange(null);
                        }}
                        onYes={() => {
                            if (pendingBlurChange?.onConfirmChange) pendingBlurChange?.onConfirmChange(true);
                            else applyAutoPopulateGlobally(null, pendingBlurChange?.fieldKey, true);
                            setPendingBlurChange(null);
                        }}
                        onCloseModal={handleBlurConfirmationClose}
                    />
                }
                onCancel={handleBlurConfirmationClose}
            />
        );
    };
    const allFields = useMemo(() => getVisibilityConditionFields(data), [data]);
    const shouldShowField = useCallback(field => shouldShowFieldByVisibility(field, allFields), [allFields]);

    const traverseAutoPopulate = useCallback(
        (fieldKey, currentValue = null) => {
            const directTargets = allFields?.[fieldKey]?.auto_populate_fields ?? [];

            const resultKeys = directTargets.filter(
                targetKey => shouldShowField(allFields?.[targetKey]) && (currentValue === null || allFields?.[targetKey]?.value !== currentValue)
            );

            return [...new Set(resultKeys)]?.map(key => allFields?.[key]?.label ?? key)?.filter(Boolean);
        },
        [allFields, shouldShowField]
    );

    const getAllAutoPopulateTargets = useCallback(fieldKey => traverseAutoPopulate(fieldKey, null), [traverseAutoPopulate]);

    const handleBlurAutoPopulate = useCallback(
        (fieldKey, bandKey, currentValue) => {
            const directAutoPopulate = allFields?.[fieldKey]?.auto_populate_fields ?? [];
            if (!directAutoPopulate.length) return;

            const targetLabels = traverseAutoPopulate(fieldKey, currentValue);
            if (!targetLabels?.length) return;

            setPendingBlurChange({
                fieldKey,
                bandKey,
                sourceLabel: allFields?.[fieldKey]?.label ?? fieldKey,
                targetLabels
            });
        },
        [allFields, traverseAutoPopulate]
    );
    const handleFieldChange = (eachFieldkey, eachFieldValue, eachBand, field_options, e, value) => {
        const selectedValue = e?.value;
        const isNewField =
            (field_options?.[0]?.label === "New" && field_options?.[0]?.options?.some(opt => opt?.value === selectedValue)) ||
            (field_options?.[0]?.label === "New" &&
                field_options?.[0]?.options?.some(opt => opt?.value === (typeof e === "string" ? e : selectedValue)));

        const newValue = getValue(eachFieldValue?.field_type, e, value);
        const autoPopulateFields = eachFieldValue?.auto_populate_fields ?? [];
        const targetLabels = autoPopulateFields.length > 0 ? getAllAutoPopulateTargets(eachFieldkey) : [];

        if (
            ["custom_select", DYNAMIC_FIELD_TYPES.SELECT, DYNAMIC_FIELD_TYPES.DATE, DYNAMIC_FIELD_TYPES.BOOLEAN].includes(
                eachFieldValue?.field_type
            ) &&
            targetLabels.length > 0
        ) {
            setPendingBlurChange({
                fieldKey: eachFieldkey,
                band: eachBand,
                sourceLabel: eachFieldValue?.label ?? eachFieldkey,
                targetLabels,
                onConfirmChange: isConfirmed => {
                    handleChange({ name: eachFieldkey, value: newValue }, null, isNewField, isConfirmed);
                }
            });
        } else {
            handleChange({ name: eachFieldkey, value: newValue }, null, isNewField);
        }
    };

    const renderFormFields = (eachFieldkey, eachFieldValue, eachBand, index, colSize) => {
        const hasValue = basicDetails?.[eachBand]?.[eachFieldkey]?.value || eachFieldValue?.value;
        const customFieldOptions =
            eachFieldValue?.field_type === DYNAMIC_FIELD_TYPES.SELECT ? basicDetails?.[eachBand]?.[eachFieldkey]?.field_options : null;
        const isInvalid = basicDetails?.[eachBand]?.[eachFieldkey]?.invalid || (eachFieldValue?.invalid && !eachFieldValue?.uuid);
        const uniformatLevel = Number(eachFieldValue?.field_name?.match(/^assets\.uniformat_level_(\d+)_id$/)?.[1]);
        const isUniformatField = eachFieldValue?.field_type === "custom_select" && uniformatLevel > 1;
        const uniformatDropdownKey = `${eachBand}-${eachFieldkey}`;
        const showFullUniformatDropdown = showFullUniformatDropdowns?.[uniformatDropdownKey];
        const dropdownOptions = isMobileRecommendation
            ? recomDropdown(eachFieldkey, eachFieldValue, eachBand)
            : dropDownList?.[dropdownKeys?.[eachFieldkey]];
        const field_options =
            isInvalid && hasValue
                ? [
                      {
                          label: "New",
                          options: uniqBy(
                              [
                                  {
                                      label: basicDetails?.[eachBand]?.[eachFieldkey]?.value,
                                      value: basicDetails?.[eachBand]?.[eachFieldkey]?.value
                                  },
                                  ...(eachFieldValue?.invalid && !eachFieldValue?.uuid && eachFieldValue?.value
                                      ? [
                                            {
                                                label: eachFieldValue?.value,
                                                value: eachFieldValue?.value
                                            }
                                        ]
                                      : [])
                              ],
                              "value"
                          )
                      },
                      {
                          label: "Existing",
                          options:
                              eachFieldValue?.field_type === "custom_select"
                                  ? eachFieldValue?.field_name?.startsWith("assets.uniformat_level")
                                      ? (getFilteredUniformatOptions(eachFieldValue?.field_name, eachBand, showFullUniformatDropdown) || [])?.sort(
                                            (a, b) => a?.label?.localeCompare(b?.label)
                                        )
                                      : eachFieldValue?.field_name?.startsWith("assets.cs_l") ||
                                        eachFieldValue?.field_name?.startsWith("assets.survey_target_id") ||
                                        eachFieldValue?.field_name?.startsWith("assets.client_standards_id")
                                      ? (getFilteredOptions(eachFieldValue?.field_name, eachBand) || [])?.map(eachOption => ({
                                            label: eachOption?.name,
                                            value: eachOption?.id
                                        }))
                                      : (dropdownOptions ?? [])?.map(eachOption => ({
                                            label: eachOption?.name,
                                            value: eachOption?.id
                                        }))
                                  : customFieldOptions?.map(e => ({
                                        label: e?.value,
                                        value: e?.value
                                    })) ?? []
                      }
                  ]
                : eachFieldValue?.field_type === "custom_select"
                  ? eachFieldValue?.field_name?.startsWith("assets.uniformat_level")
                      ? (getFilteredUniformatOptions(eachFieldValue?.field_name, eachBand, showFullUniformatDropdown) || [])?.sort((a, b) =>
                            a?.name?.localeCompare(b?.name)
                        )
                      : eachFieldValue?.field_name?.startsWith("assets.cs_l") ||
                          eachFieldValue?.field_name?.startsWith("assets.survey_target_id") ||
                          eachFieldValue?.field_name?.startsWith("assets.client_standards_id")
                        ? getFilteredOptions(eachFieldValue?.field_name, eachBand)
                        : eachFieldValue?.field_name === "recommendation_status_id" && isMobileRecommendation
                          ? (groupedOptions ?? [])
                          : (dropdownOptions ?? [])
                  : (customFieldOptions?.map(e => ({
                        id: e?.value,
                        name: isMobileRecommendation ? e?.label || e?.value : e?.value
                    })) ?? []);
        const audioText =
            [...(getAssetVoiceNotesResponse?.data?.audio ?? [])]?.reduce((acc, item) => {
                acc = acc ? `${acc} <br/><br/> ${item?.voice_text ?? ""}` : (item?.voice_text ?? "");
                return acc;
            }, "") || "";
        return (
            <FormField
                key={`${eachBand}-${eachFieldkey}`}
                isLoading={
                    isMobileRecommendation
                        ? getMobileRecommendationDropdownResponseLoading?.[eachFieldkey]
                        : dropDownLoading?.[dropdownKeys?.[eachFieldkey]]
                }
                label={eachFieldValue?.label}
                labelAddon={isUniformatField ? renderUniformatFullDropdownToggle(uniformatDropdownKey) : null}
                fieldKey={eachFieldkey}
                fieldParam={eachFieldkey}
                fieldType={
                    isMobileRecommendation
                        ? eachFieldValue?.field_type
                        : autoFields.includes(eachFieldkey)
                          ? DYNAMIC_FIELD_TYPES.TEXT
                          : eachFieldValue?.field_type
                }
                value={
                    !autoFields.includes(eachFieldkey) && ["custom_select"].includes(eachFieldValue?.field_type)
                        ? eachFieldValue?.invalid
                            ? eachFieldValue?.value
                            : eachFieldValue?.uuid
                        : isMobileRecommendation && eachFieldValue?.field_name === "mobile_recomm_notes_temp"
                          ? audioText
                          : eachFieldValue?.value
                }
                bandId={`band${index + 1}`}
                bandShown={showBand}
                handleBandClick={(band, value) => setShowBand({ ...showBand, [band]: value })}
                onChange={(e, value) => {
                    handleFieldChange(eachFieldkey, eachFieldValue, eachBand, field_options, e, value);
                }}
                showErrorBorder={showErrorBorder && errorParams?.[eachFieldkey]}
                fieldItem={{
                    field_options,
                    rules: {
                        mandatory: eachFieldValue?.rules?.mandatory,
                        read_only:
                            (isMobileRecommendation
                                ? getMobileRecommendationDropdownResponseLoading?.[eachFieldkey] ||
                                  eachFieldValue?.field_name === "mobile_recomm_notes_temp" ||
                                  eachFieldValue?.rules?.read_only
                                : eachFieldValue?.field_name !== "assets.manufacturer" && dropDownLoading?.[dropdownKeys?.[eachFieldkey]]) ||
                            (autoFields.includes(eachFieldkey) && !isMobileRecommendation) ||
                            disabledKeys.includes(eachFieldkey) ||
                            eachFieldValue?.rules?.read_only,
                        decimal_scale: eachFieldValue?.rules?.decimal_scale,
                        allow_negative: eachFieldValue?.rules?.allow_negative,
                        thousand_separator: eachFieldValue?.rules?.thousand_separator,
                        prefix: eachFieldValue?.rules?.prefix,
                        suffix: eachFieldValue?.rules?.suffix,
                        ...(isMobileRecommendation && eachFieldValue?.field_name === "installed_year"
                            ? { format: eachFieldValue?.rules?.format }
                            : {})
                    },
                    invalid: eachFieldValue?.invalid && eachFieldValue?.value,
                    tooltip: eachFieldValue?.tooltip,
                    className: isMobileRecommendation ? "mob-recom-field" : ""
                }}
                isAsset
                isSurveyAssetField
                hasGroupedByOptions={(isInvalid && hasValue) || (eachFieldValue?.field_name === "recommendation_status_id" && isMobileRecommendation)}
                isMobileRecommendation={isMobileRecommendation}
                toggleCreateDynamicForm={toggleCreateDynamicForm}
                suggestionArray={
                    isMobileRecommendation
                        ? eachFieldkey === "description"
                            ? getSuggestions() || []
                            : []
                        : (getSuggestionDropdown?.data ?? [])?.find(e => e?.key === eachFieldkey)?.value ?? []
                }
                manufacturerCount={
                    eachFieldValue?.field_name === "assets.manufacturer" ||
                    eachFieldValue?.field_name === "manufacturer_id" ||
                    eachFieldValue?.field_name === "assets.manufacturer_id"
                        ? manufacturerCount?.count
                        : 0
                }
                isManufacturer={
                    isMobileRecommendation
                        ? eachFieldValue?.field_name === "manufacturer_id" || eachFieldValue?.field_name === "assets.manufacturer_id"
                        : eachFieldValue?.field_name === "assets.manufacturer"
                }
                handleInputChange={(newValue, { action }) =>
                    (eachFieldValue?.field_name === "assets.manufacturer" ||
                        eachFieldValue?.field_name === "manufacturer_id" ||
                        eachFieldValue?.field_name === "assets.manufacturer_id") &&
                    handleInputChange(newValue, { action }, eachFieldValue?.uuid)
                }
                isLoadingDrop={
                    (eachFieldValue?.field_name === "manufacturer_id" ||
                        eachFieldValue?.field_name === "assets.manufacturer_id" ||
                        eachFieldValue?.field_name === "assets.manufacturer") &&
                    dropDownLoading?.[dropdownKeys?.[eachFieldValue?.field_name]]
                }
                colSize={colSize}
                multiselectClass={() => (isMobileRecommendation && eachFieldkey === "description" ? "mobile-recom-autosuggestion" : "")}
                hasSuggestionSearch={isMobileRecommendation && eachFieldkey === "description"}
                hasSuggestionClear={isMobileRecommendation && eachFieldkey === "description"}
                onBlur={() => handleBlurAutoPopulate(eachFieldkey, eachBand, data?.[eachBand]?.[eachFieldkey]?.value)}
                searchText={fieldSearch}
            />
        );
    };

    const renderStaticFields = (eachField, eachBand, index) => {
        const value = staticData?.[eachField?.key] ?? "-";
        const dateFields = ["synced_time", "created_at", "updated_at", "asset_surveyed_time", "modified_time"];
        return (
            <FormField
                key={`${eachBand}-${eachField?.key}`}
                label={eachField?.label}
                fieldKey={eachField?.key}
                fieldParam={eachField?.key}
                fieldType={!dateFields?.includes(eachField?.key) ? DYNAMIC_FIELD_TYPES.TEXT : DYNAMIC_FIELD_TYPES?.DATE}
                value={value}
                bandId={`band${index + 1}`}
                bandShown={showBand}
                handleBandClick={(band, value) => setShowBand({ ...showBand, [band]: value })}
                fieldItem={{
                    rules: {
                        read_only: true
                    }
                }}
                isAsset
                isMobileRecommendation={isMobileRecommendation}
                isStaticField
                suggestionArray={[]}
                searchText={fieldSearch}
            />
        );
    };
    const mobRecomSearchFields = () => {
        const FilteredFieldData = Object.entries(data ?? {})?.reduce((acc, [bandKey, bandFields]) => {
            const lowerBand = bandKey.toLowerCase();

            if (lowerBand === "narrative") return acc;
            if (lowerBand === "asset" && data?.Recommendations?.recommendation_type?.value !== "asset") return acc;

            const filteredFields = Object.entries({ ...bandFields } ?? {})
                .filter(([fieldKey, field]) => {
                    if (!shouldShowField(field)) return false;
                    if (
                        data?.Recommendations?.recommendation_type?.value?.toLowerCase() === "asset" &&
                        ["asset_condition_id", "installed_year", "service_life", "usefull_life_remaining", "crv"].includes(fieldKey.toLowerCase())
                    )
                        return false;
                    const isFiltered = field?.label?.toLowerCase().includes(fieldSearch.toLowerCase());
                    return showType ? isFiltered && showFields.includes(fieldKey) : isFiltered;
                })
                .map(([fieldKey, field]) => ({
                    label: field?.label ?? "",
                    band: bandKey,
                    key: fieldKey
                }));
            return [...acc, ...filteredFields];
        }, []);
        return FilteredFieldData;
    };

    return (
        <LoadingOverlay active={isLoading || getAssetVoiceNotesResponseLoading || getSuggestionDropdownLoading} spinner={<Loader />} fadeSpeed={10}>
            {renderCancelConfirmationModal()}
            {renderCreateDynamicFormModal()}
            {renderEmptyFieldsConfirmationModal()}
            {renderInvalidModal()}
            {renderBlurConfirmationModal()}
            {renderServiceLifeChangeConfirmationModal()}
            {selectedTabs === "edit" && renderImagePopup()}
            {selectedTabs === "edit" && renderSignaturePopup()}
            <div className="dtl-sec col-md-12">
                <div className="tab-dtl region-mng">
                    <ul>
                        {initialTabs.map((e, i) => {
                            return (
                                <li
                                    onClick={() => setSelectedTabs(e?.key)}
                                    className={`${selectedTabs === e?.key ? "active" : ""} ${i === 0 ? "pl-4" : ""}  cursor-pointer`}
                                    key={e?.key}
                                >
                                    {e?.label}
                                </li>
                            );
                        })}
                    </ul>
                    {selectedTabs === "edit" ? (
                        <form autoComplete={"nope"}>
                            <ReactTooltip id="survey-edit" effect="solid" place="top" backgroundColor="#007bff" className="rc-tooltip-custom-class" />
                            <div className={`tab-dtl region-mng additional-dtl addition-edit ${isMobileRecommendation ? "mob-recom-main" : ""}`}>
                                <div
                                    className={`tab-active location-sec recom-sec main-dtl-add recommendation-form add-recommendation ${
                                        isMobileRecommendation ? "recom-mob-scroll edit-mob-recom" : ""
                                    }`}
                                >
                                    <div class="header-mod-top d-flex edit-asset-mob">
                                        <div className="d-flex">
                                            {isMobileRecommendation ? (
                                                <ul className="mt-0 mr-2 mobile-rec-edit-innertab">
                                                    <li
                                                        className={activeTab === "basic" ? "active cursor-hand" : "cursor-hand"}
                                                        onClick={() => {
                                                            setActiveTab("basic");
                                                        }}
                                                    >
                                                        Basic Details
                                                    </li>
                                                    {basicDetails?.has_check_list && (
                                                        <li
                                                            className={activeTab === "checklist" ? "active cursor-hand" : "cursor-hand"}
                                                            onClick={() => {
                                                                setActiveTab("checklist");
                                                            }}
                                                        >
                                                            Checklists
                                                        </li>
                                                    )}
                                                </ul>
                                            ) : null}
                                            {activeTab !== "checklist" && (
                                                <>
                                                    <div className="search search-box-asset mr-2 mt-2 not-draggable">
                                                        <FilterSearch
                                                            fieldSearch={fieldSearch}
                                                            setFieldSearch={setFieldSearch}
                                                            fields={
                                                                isMobileRecommendation
                                                                    ? mobRecomSearchFields()
                                                                    : [
                                                                          ...surveyDetailMainFields,
                                                                          ...surveyDetailRestFields,
                                                                          ...Object.values(data ?? {}).reduce((acc, item) => {
                                                                              acc = [
                                                                                  ...acc,
                                                                                  ...Object.keys(item ?? {})
                                                                                  .filter(e => shouldShowField(item?.[e]))
                                                                                  .map(e => ({ label: item?.[e]?.label }))
                                                                              ];
                                                                              return acc;
                                                                          }, [])
                                                                      ]
                                                            }
                                                        />
                                                    </div>
                                                    {!showType ? (
                                                        <>
                                                            {(showFields?.length ||
                                                                Object.values(data ?? {}).some(eachBand => {
                                                                    return Object.keys(eachBand ?? {}).some(each => {
                                                                        if (!shouldShowField(eachBand?.[each])) return false;
                                                                        if (
                                                                            data?.Recommendations?.recommendation_type?.value === "asset" &&
                                                                            eachBand?.[each]?.group_field?.toLowerCase() === "additional details" &&
                                                                            isMobileRecommendation &&
                                                                            each === "asset_condition_id"
                                                                        ) {
                                                                            return false;
                                                                        }
                                                                        if (
                                                                            data?.Recommendations?.recommendation_type?.value === "system" &&
                                                                            eachBand?.[each]?.group_field?.toLowerCase() === "asset" &&
                                                                            isMobileRecommendation
                                                                        ) {
                                                                            return false;
                                                                        } else return ["", null, undefined].includes(eachBand?.[each]?.value);
                                                                    });
                                                                })) && (
                                                                <button
                                                                    type="button"
                                                                    className={"add-btn ml-2 btn-new-noti"}
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        const emptyFields = Object.values(data ?? {}).reduce((acc, item) => {
                                                                            const keysToAdd = Object.keys(item ?? {}).filter(key => {
                                                                                const field = item?.[key];
                                                                                if (!shouldShowField(field)) return false;
                                                                                if (
                                                                                    data?.Recommendations?.recommendation_type?.value === "asset" &&
                                                                                    field?.group_field?.toLowerCase() === "additional details" &&
                                                                                    isMobileRecommendation &&
                                                                                    key === "asset_condition_id"
                                                                                ) {
                                                                                    return false;
                                                                                }
                                                                                return ["", null, undefined].includes(field?.value);
                                                                            });
                                                                            acc = [...acc, ...keysToAdd];
                                                                            return acc;
                                                                        }, []);
                                                                        setShowType("empty");
                                                                        setShowFields(showFields?.length ? [] : emptyFields);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-eye mr-1" />
                                                                    Show Empty Fields
                                                                </button>
                                                            )}
                                                            {(showFields?.length ||
                                                                Object.values(data ?? {}).some(eachBand => {
                                                                    return Object.keys(eachBand ?? {}).some(each => {
                                                                        if (!shouldShowField(eachBand?.[each])) return false;
                                                                        if (
                                                                            data?.Recommendations?.recommendation_type?.value === "asset" &&
                                                                            eachBand?.[each]?.group_field?.toLowerCase() === "additional details" &&
                                                                            isMobileRecommendation &&
                                                                            each === "asset_condition_id"
                                                                        ) {
                                                                            return false;
                                                                        }

                                                                        if (
                                                                            data?.Recommendations?.recommendation_type?.value === "system" &&
                                                                            eachBand?.[each]?.group_field?.toLowerCase() === "asset" &&
                                                                            isMobileRecommendation
                                                                        ) {
                                                                            return false;
                                                                        }

                                                                        return eachBand?.[each]?.invalid;
                                                                    });
                                                                })) && (
                                                                <button
                                                                    className={"add-btn ml-2 btn-new-noti"}
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        const newFields = Object.values(data ?? {}).reduce((acc, item) => {
                                                                            const keysToAdd = Object.keys(item ?? {}).filter(key => {
                                                                                const field = item?.[key];
                                                                                if (!shouldShowField(field)) return false;
                                                                                if (
                                                                                    data?.Recommendations?.recommendation_type?.value === "asset" &&
                                                                                    field?.group_field?.toLowerCase() === "additional details" &&
                                                                                    isMobileRecommendation &&
                                                                                    key === "asset_condition_id"
                                                                                ) {
                                                                                    return false;
                                                                                }
                                                                                return field?.invalid && field?.value;
                                                                            });
                                                                            acc = [...acc, ...keysToAdd];
                                                                            return acc;
                                                                        }, []);
                                                                        setShowType("new");
                                                                        setShowFields(newFields);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-eye mr-1" />
                                                                    Show New Fields
                                                                </button>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <button
                                                            className={"add-btn ml-2 btn-new-noti"}
                                                            onClick={e => {
                                                                setShowType(null);
                                                                setShowFields([]);
                                                            }}
                                                        >
                                                            <i className="fas fa-eye mr-1" />
                                                            Show All Fields
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        <div className="text-right btnOtr edit-cmn-btn-outer btn-mob-rcm">
                                            {!isMobileRecommendation ? (
                                                <span className="errorMessage">
                                                    {showErrorBorder && Object.keys(errorParams)?.length ? Object.values(errorParams)[0] : ""}
                                                </span>
                                            ) : null}
                                            <span
                                                className="edit-icn-bx modal-view-icn p-0 pr-3"
                                                onClick={() => setImagePopup(!imagePopup)}
                                                data-tip={"Image View Popup"}
                                                data-for="survey-edit"
                                                data-place="bottom"
                                                data-effect="solid"
                                            >
                                                <img src="/img/img-icon.svg" alt="" />
                                            </span>
                                            {!isMobileRecommendation && checkPermission("forms", "signatures", "view") && (
                                                <span
                                                    className="edit-icn-bx icon-btn-sec ml-0 mr-2 d-no-flex signature-view-icn"
                                                    onClick={() => {
                                                        dispatch(actions.getAssetSignature("mobile_asset", id));
                                                        setSignaturePopup(true);
                                                    }}
                                                    data-tip={"Signature View Popup"}
                                                    data-for="survey-edit"
                                                    data-place="bottom"
                                                    data-effect="solid"
                                                >
                                                    <img src={signatureIcon} alt="" />
                                                </span>
                                            )}
                                            <button type="button" className="btn btn-secondary btnClr mr-1" onClick={onCancel}>
                                                Cancel
                                            </button>
                                            {updateSurveyAssetFieldsResponseLoading || updateMobileRecommendationFieldsResponseLoading ? (
                                                <button type="button" className="btn btn-primary btnRgion ml-2 cursor-diabled">
                                                    <div className="button-loader d-flex justify-content-center align-items-center">
                                                        <div className="spinner-border text-white" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary btnRgion  ${_.isEqual(initialData, data) ? "cursor-diabled" : ""}`}
                                                    disabled={_.isEqual(initialData, data)}
                                                    onClick={() => {
                                                        const isInvalid = hasInvalidFields();
                                                        if (!isInvalid) handleSubmit();
                                                    }}
                                                >
                                                    Update
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    {isMobileRecommendation ? (
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <span className="errorMessage">
                                                {showErrorBorder && Object.keys(errorParams)?.length ? Object.values(errorParams)[0] : ""}
                                            </span>
                                        </div>
                                    ) : null}
                                    <div className={`col-md-12 detail-recom add-details-outer ${activeTab === "checklist" ? "p-0" : ""}`}>
                                        <div className="outer-rcm recommendations suggst-drop-icon">
                                            <div className="cnt-sec">
                                                <div className="row">
                                                    {isMobileRecommendation ? (
                                                        activeTab === "checklist" ? (
                                                            <div
                                                                className={`tab-active location-sec recom-sec main-dtl-add recommendation-form add-recommendation building-type edit-ck-recom`}
                                                            >
                                                                <RecommendationChecklist
                                                                    data={data?.check_list ?? []}
                                                                    setData={value => {
                                                                        handleChange({
                                                                            name: "check_list",
                                                                            value: value
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <MobileRecommendationForm
                                                                data={data}
                                                                isMobileRecommendation={isMobileRecommendation}
                                                                fieldSearch={fieldSearch}
                                                                showFields={showFields}
                                                                showType={showType}
                                                                setShowBand={setShowBand}
                                                                renderFormFields={renderFormFields}
                                                                showBand={showBand}
                                                                getSuggestionDropdown={getSuggestionDropdown}
                                                                setShowEmptyFieldsFillModal={setShowEmptyFieldsFillModal}
                                                                handleChange={handleChange}
                                                                shouldShowField={shouldShowField}
                                                            />
                                                        )
                                                    ) : (
                                                        <div className="col-md-12 pr-0 asset-edit-port">
                                                            <div id="accordion">
                                                                {!isMobileRecommendation && (
                                                                    <>
                                                                        <div className="d-flex">
                                                                            <div className="col-md-8 p-0">
                                                                                <AssetBand
                                                                                    key="survey-details"
                                                                                    label={"Survey Details"}
                                                                                    bandId={`band${100 + 1}`}
                                                                                    handleBandClick={(band, value) =>
                                                                                        setShowBand({ ...showBand, [band]: value })
                                                                                    }
                                                                                    isDefaultOpen
                                                                                    showBand={showBand}
                                                                                    MainFields={surveyDetailMainFields.map((eachField, index) => {
                                                                                        return renderStaticFields(eachField, "Survey Details", index);
                                                                                    })}
                                                                                    RestFields={surveyDetailRestFields.map((eachField, index) => {
                                                                                        return renderStaticFields(eachField, "Survey Details", index);
                                                                                    })}
                                                                                    isStaticBand
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4 edit-asset-mb mb-2">
                                                                                <RenderImageBand
                                                                                    imageList={imageList}
                                                                                    imageLoaded={imageLoaded}
                                                                                    resetRef={resetRef}
                                                                                    zoomInRef={zoomInRef}
                                                                                    zoomOutRef={zoomOutRef}
                                                                                    selectedImage={selectedImage}
                                                                                    setShowAdditionalButtons={setShowAdditionalButtons}
                                                                                    viewImageHandler={viewImageHandler}
                                                                                    key="band"
                                                                                    getSurveyAssetImagesById={getSurveyAssetImagesById}
                                                                                    showAdditionalButtons={showAdditionalButtons}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}

                                                                {Object.keys(data ?? {})
                                                                    .filter(eachBand =>
                                                                        Object.keys(data?.[eachBand] ?? {})?.some(each => {
                                                                            if (!shouldShowField(data?.[eachBand]?.[each])) return false;
                                                                            const isFiltered = (data?.[eachBand]?.[each]?.label ?? "")
                                                                                .toLowerCase()
                                                                                .includes(fieldSearch.toLowerCase());
                                                                            return showType ? isFiltered && showFields.includes(each) : isFiltered;
                                                                        })
                                                                    )
                                                                    .map((eachBand, index) => {
                                                                        let mainFields = {};
                                                                        let restFields = {};
                                                                        Object.keys(data?.[eachBand] ?? {})
                                                                            .filter(eachKey => {
                                                                                if (!shouldShowField(data?.[eachBand]?.[eachKey])) return false;
                                                                                const isFiltered = data?.[eachBand]?.[eachKey]?.label
                                                                                    ?.toLowerCase()
                                                                                    .includes(fieldSearch?.toLowerCase());
                                                                                return showType
                                                                                    ? isFiltered && showFields.includes(eachKey)
                                                                                    : isFiltered;
                                                                            })
                                                                            .forEach((eachKey, i) => {
                                                                                if (i < 3)
                                                                                    mainFields = {
                                                                                        ...mainFields,
                                                                                        [eachKey]: data?.[eachBand]?.[eachKey]
                                                                                    };
                                                                                else
                                                                                    restFields = {
                                                                                        ...restFields,
                                                                                        [eachKey]: data?.[eachBand]?.[eachKey]
                                                                                    };
                                                                            });
                                                                        return (
                                                                            <AssetBand
                                                                                key={eachBand}
                                                                                label={eachBand}
                                                                                bandId={`band${index + 1}`}
                                                                                handleBandClick={(band, value) =>
                                                                                    setShowBand({ ...showBand, [band]: value })
                                                                                }
                                                                                isDefaultOpen
                                                                                showBand={showBand}
                                                                                MainFields={Object.entries(mainFields).map(
                                                                                    ([eachFieldkey, eachFieldValue]) => {
                                                                                        return renderFormFields(
                                                                                            eachFieldkey,
                                                                                            eachFieldValue,
                                                                                            eachBand,
                                                                                            index
                                                                                        );
                                                                                    }
                                                                                )}
                                                                                RestFields={Object.entries(restFields).map(
                                                                                    ([eachFieldkey, eachFieldValue]) => {
                                                                                        return renderFormFields(
                                                                                            eachFieldkey,
                                                                                            eachFieldValue,
                                                                                            eachBand,
                                                                                            index
                                                                                        );
                                                                                    }
                                                                                )}
                                                                                isSurveyAsset={!isMobileRecommendation}
                                                                                fillEmptyFields={() => {
                                                                                    setShowEmptyFieldsFillModal({
                                                                                        show: true,
                                                                                        fields: Object.keys(data?.[eachBand] ?? {}).filter(
                                                                                            eachField =>
                                                                                                shouldShowField(data?.[eachBand]?.[eachField])
                                                                                        )
                                                                                    });
                                                                                }}
                                                                                showFillEmptyField={Object.keys(data?.[eachBand] ?? {}).some(
                                                                                    eachField => {
                                                                                        if (!shouldShowField(data?.[eachBand]?.[eachField]))
                                                                                            return false;
                                                                                        const suggestionValue = (
                                                                                            getSuggestionDropdown?.data ?? []
                                                                                        )?.find(e => e?.key === eachField)?.value;
                                                                                        return (
                                                                                            data?.[eachBand]?.[eachField]?.field_type === "text" &&
                                                                                            !data?.[eachBand]?.[eachField]?.value &&
                                                                                            (!suggestionValue ||
                                                                                                (suggestionValue && suggestionValue?.includes("NA")))
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            />
                                                                        );
                                                                    })}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    ) : selectedTabs === "voice" ? (
                        <VoiceNotesTable isRecommendation={isMobileRecommendation} />
                    ) : selectedTabs === "video" ? (
                        <VideoTable isRecommendation={isMobileRecommendation} />
                    ) : selectedTabs === "ai-analyse" ? (
                        <div className="tab-active location-sec recom-sec add-recommendation asset-viewer-outer">
                            <AIAnalyse detailedData={staticData} isMobEdit={isMobileRecommendation} />
                        </div>
                    ) : (
                        <InfoImages
                            isRecommendation={isMobileRecommendation}
                            basicDetails={
                                isMobileRecommendation
                                    ? { ...basicDetails, value: { ...basicDetails, project_id: { uuid: projectId ?? "" } } } ?? {}
                                    : basicDetails ?? {}
                            }
                            updateImageComment={updateImageComment}
                            // isMobileRecommendation={isMobileRecommendation}
                            isCompletedAsset={!isMobileRecommendation && getSurveyAssetById?.data?.asset.status !== 5}
                            isMobRecom={isMobileRecommendation ?? false}
                            hasEdit={checkPermission("forms", isMobileRecommendation ? "mobile_recommendations" : "mobile_assets", "edit")}
                            hasDelete={checkPermission("forms", isMobileRecommendation ? "mobile_recommendations" : "mobile_assets", "edit")}
                            hasCreate={checkPermission("forms", isMobileRecommendation ? "mobile_recommendations" : "mobile_assets", "edit")}
                        />
                    )}
                </div>
            </div>
        </LoadingOverlay>
    );
};

export default AssetsForm;
